<template>
  <table>
    <tr style="border-bottom: 1pt solid #000; display: table-row;" class="header-serial-number">
      <td  style="padding: 0px;padding-bottom: 3px;font-size: 6pt;/*font-size: 7.7pt;*/font-family: 'Roboto-Bold'; line-height: 9pt; " class="title left-title">{{ title }} <p style="line-height: 5pt !important;display: block; margin-bottom: 0px;" class="down-line-custom" >& HƯỚNG DẪN SỬ DỤNG</p></td>
      <td  style="padding: 0px;padding-bottom: 3px;font-size: 6pt;/*font-size: 7.7pt;*/font-family: 'Roboto-Bold'; line-height: 9pt;text-align: right!important; " class="title left-title">{{ modelCodeFirts }} <p style="line-height: 5pt !important;display: block; margin-bottom: 0px;" class="down-line-custom" >{{ modelCodeLast }}</p></td>
<!--      <td  class="title right-title txt-right" >{{ modelCode }}</td>-->
<!--      <td style="font-size: 6pt; font-family: 'Roboto-Bold';line-height: 9pt; padding: 0;padding-bottom: 3px;  /*position: relative;*/ top: 4.4pt; right: 0.15cm;text-align: right !important;" class="title right-title txt-right" >{{ modelCodeFirts }} <p style="line-height: 5pt !important;display: block; margin-bottom: 0px;" class="down-line-custom" >{{ modelCodeLast }}</p></td>-->
    </tr>
    <tr style="display: table-row;" class="body-serial-number">
      <td style="width: 2.6cm; padding: 0;" class="body-info">
        <div style="font-size: 6.8pt; font-family: 'UTM AvoBold'; line-height: 8.5pt; margin-bottom: 0cm; margin-top: 0.125cm; position: relative; top: -0.1cm;" class="item-info note-info" ><!--<br><br><br>--> {{ note }}</div>
        <div style="padding-top: 0cm; font-size: 8.1pt; font-family: 'UTM AvoBold';border-top: 0.9232pt solid #000; border-bottom: 0.9232pt solid #000; display: flex; width: 2.53cm; overflow: hidden;" class="item-info border-custom" > <img :src="imgPhone"/><span style="margin-bottom: 0px">{{ hotline }} </span></div>
        <div style="line-height: 11pt;font-family: 'UTM AvoBold'; text-align: left;" class="item-info serial" ><span style="font-size: 6.6pt; position: relative; /*top: 0.0158cm;*/top: -0.1cm;">SERI:</span> <abbr style="line-height: 7pt;display: block;/*font-size: 7.2pt;*/font-size: 6.5pt; position: relative; /*top: 0.001cm;*/top: -0.15cm;">{{ serialNumber }}</abbr> </div>
      </td>
      <td class="body-qr" style="/*margin-top: -15px;*/">
        <qrCode :logoUrl="logoUrl" :logoSize="logoSize" :codeSize="codeSize" :codeValue="codeValue"/>
      </td>
    </tr>
  </table>
</template>

<script>
import qrCode from './qrCode'
export default {
  props: {
    logoUrl: {
      type: String,
      default: ''
    },
    logoSize: Number,
    codeValue: String,
    codeSize: Number,
    modelCode: String,
    serialNumber: String,
    styleBox: String,
    title: String,
    note: String,
    hotline: String
  },
  components: {
    qrCode
  },
  data() {
    return {
      imgPhone: window.origin + '/assets/images/phone-icon-01.svg',
      title_size: this.$myConstants.converMillimeterToPixel(2.3),
      body_size: this.$myConstants.converMillimeterToPixel(1.9),
      header_padding_bottom: this.$myConstants.converMillimeterToPixel(1),
      qrSize: this.$myConstants.converMillimeterToPixel(20),
      box_padding: this.$myConstants.converMillimeterToPixel(1),
      modelCodeFirts:"",
      modelCodeLast:"",
    }
  },
  created() {
    var object_model=this.$coreService.splitModelNameQrcode(this.modelCode);
    this.modelCodeFirts=object_model.modelCodeFirts;
    this.modelCodeLast=object_model.modelCodeLast;
  },
}
</script>
<style lang="css">
.body{width: 5cm; margin: 0; padding: 0; }
.txt-right{text-align: right;}
.board-item{position: relative; background: #fff; width: 5cm;  margin: 0; /*margin-left: 0.3cm;*/ page-break-after: always; margin-bottom: 10px;}
.board-item table { border-collapse: collapse; width: 100%; }
.header-serial-number{ border-bottom: 1pt solid #000; display: table-row; }
.header-serial-number .left-title { font-size: 5pt;/*font-size: 7.7pt;*/font-family: "Roboto-Bold"; line-height: 9pt; padding: 0; padding-bottom: 0.0139cm;}
.header-serial-number .right-title { font-size: 5pt; font-family: "Roboto-Bold"; padding: 0; padding-bottom: 0.0139cm; /*position: relative;*/ top: 4.4pt; right: 0.15cm;text-align: right !important;}
.body-serial-number{display: table-row;}
.body-serial-number .body-info {width: 2.6cm; padding: 0;}
.body-serial-number .note-info {font-size: 6.8pt; font-family: "UTM AvoBold"; line-height: 8.729pt; margin-bottom: 0.08cm; margin-top: 0.125cm; position: relative; top: -0.1cm;}
.body-serial-number .border-custom {padding-top: 0.03cm; font-size: 8.1pt; font-family: "UTM AvoBold";border-top: 0.9232pt solid #000; border-bottom: 0.9232pt solid #000; display: flex; width: 2.53cm; overflow: hidden;}
.body-info .border-custom img{margin-top: 0.075cm; width: 0.1726cm; top: -0.07cm; left: 0.03cm; position: relative; margin-right: 0.177cm;}
.body-serial-number .border-custom span{position: relative; margin-top: 0.0066cm;margin-bottom: 0.14cm; line-height: 9pt;}
.body-serial-number .serial {font-family: 'UTM AvoBold'; text-align: left;}
.body-serial-number .serial span{font-size: 6.6pt; position: relative; /*top: 0.0158cm;*/top: -0.1cm;}
.body-info .item-info abbr{display: block;/*font-size: 7.2pt;*/font-size: 6.5pt; position: relative; /*top: 0.001cm;*/top: -0.15cm;}
.body-qr .qr-custom{  width: 2cm; height: 2cm; margin: 0 auto; float: right; position: relative; /*margin-top:0.2cm;*/margin-top:-15px;}
.qr-custom img{max-width: 100%; height: auto;}
.down-line-custom{
  display: block;
  margin-bottom: 0px;
}

</style>